import React from 'react'

import {
  Table,
  TableBody,
} from '@material-ui/core'
import Skeleton from '@material-ui/lab/Skeleton';

import TableHeader from './tableHeader'
import TableRow from './tableRow'

const TableComponent = (props) => {
  const { 
    options, 
    isLoading, 
    onClickConfigure, 
  } = props

  return (
    <Table>
      {isLoading
        ?
        <div>
          <Skeleton height={80} />
          <Skeleton height={80} />
          <Skeleton height={80} />
        </div>
        :
        <>
          <TableHeader />
          <TableBody>
            {options.map((item) => (
              <TableRow
                key={item.id}
                item={item}
                onClickConfigure={onClickConfigure}
              />
            ))}
          </TableBody>
        </>
      }
    </Table>
  )
}

export default TableComponent